module.exports = "/timeclock/components/timesheetsSubNavComponent-a949c4.html";